var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.44,102.25l-2.72-4.44c-21.88-35.6-61.29-57.18-103-55A112,112,0,0,0,327.22,45c-38.39,8.11-71.79,36.78-85.64,73.5-8.14,21.59-10.42,46.45-25.87,63.59-20.11,22.31-54.26,23-84.28,22.08s-54.14,4-74.16,26.43c-12.53,14-28.3,46.42-28.33,65.23-.1,61.08,30,87,74.58,109.12s107.77,14.6,156.61,4.88c68.42-13.62,133.49-51,172.6-108.79S481.73,164.6,450.44,102.25Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.26,438.43c0,.14-95.49.26-213.25.26s-213.27-.12-213.27-.26,95.47-.26,213.27-.26S463.26,438.29,463.26,438.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.18,264.56c-.95-.35-4.14.28-7.64,1.16,5-2,6.86-3.79,6.49-5.11-.62-2.26-12.5,1.05-18,2.72,4.53-1.44,13.2-4.26,15-5.47,2.43-1.66-1-2.65-4-2.66-3.43,0-23.38,2.74-29.17,3.24-4,.34-4.12-3.21-4.12-3.21.85-8.4-3-15.39-4.91-16.8s-4.5.77-3.67,3.27c.68,2,.79,5.73.75,8.52a20.15,20.15,0,0,1-1.21,6.71c-.91,2.49-1.78,4.56-2.56,6.31l-18.78,10.7-48,22.67s-65.54-37.26-67.95-39.15l-2.41.55-16.48,35.73L325,340a17.41,17.41,0,0,0,17.58.17l56-34.48,22.16-13.37,7.09-4.65h0l17.27-11.31c7.17-3.46,9.87-5.4,9.14-6.7-1-1.73-.53-1.11-14.44,3.35C439.78,273.05,459.58,266.52,454.18,264.56Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.55,276.19c.1.35,4.43-.84,9.66-2.66s9.36-3.57,9.22-3.91-4.46.85-9.66,2.66S432.45,275.84,432.55,276.19Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.62,270.45c.1.35,4.78-.66,10.45-2.25s10.19-3.18,10.09-3.53-4.78.65-10.45,2.25S428.52,270.09,428.62,270.45Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.55,265.5c.09.35,4.54-.53,9.92-2s9.68-2.89,9.59-3.24-4.54.52-9.93,2S425.45,265.14,425.55,265.5Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.66,269.54s-42.8-30.33-48.22-33.31c-5.16-2.84-21.53-4.91-23-5.26l-29.32-6.38-44.8,1.34-12.85,7.73-32.51,15A38.59,38.59,0,0,0,85.41,269L64.88,319.18l51,15.07,1.58,52.89L105.7,438.43H254.84L247,310.76l15.53,3.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.77,312.94a16.83,16.83,0,0,1-1.57,1,13.14,13.14,0,0,1-4.76,1.75,17.88,17.88,0,0,1-7.44-1.08,54.24,54.24,0,0,1-8.47-3.68c-2.91-1.52-5.63-3.05-8.18-4.28a44.53,44.53,0,0,0-7-2.79,26.37,26.37,0,0,0-5-1c-.6-.07-1.07-.1-1.38-.11l-.48,0a14.44,14.44,0,0,1,1.86.06,25.22,25.22,0,0,1,5,1,43.48,43.48,0,0,1,7,2.76c2.56,1.22,5.28,2.75,8.19,4.27a54.71,54.71,0,0,0,8.43,3.68,17.84,17.84,0,0,0,7.37,1.11,13.26,13.26,0,0,0,4.74-1.67c.52-.3.93-.53,1.19-.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.6,288.24h-.34l-1,0c-.84,0-2.06-.13-3.56-.28A95.89,95.89,0,0,1,98.09,286a94.75,94.75,0,0,1-11.31-3.36c-1.42-.53-2.55-1-3.33-1.31l-.89-.38-.31-.14.32.1.91.35c.78.32,1.93.74,3.35,1.25a101.51,101.51,0,0,0,22.91,5.27c1.5.17,2.71.28,3.56.34l1,.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.65,236.23a19.19,19.19,0,0,1-1.19,1.67,23.26,23.26,0,0,1-4,3.92,35.68,35.68,0,0,1-7.11,4.26,72.81,72.81,0,0,1-9.54,3.48c-3.45,1-6.76,1.93-9.72,2.9a58.3,58.3,0,0,0-7.68,3.07,33.73,33.73,0,0,0-4.78,2.85c-.55.37-.93.71-1.21.92l-.43.31s.54-.49,1.59-1.29a32.32,32.32,0,0,1,4.77-2.91,54.57,54.57,0,0,1,7.69-3.11c3-1,6.27-1.9,9.72-2.92a73.84,73.84,0,0,0,9.51-3.46,35.29,35.29,0,0,0,7.1-4.2,23.72,23.72,0,0,0,4-3.87c.44-.49.71-.93.93-1.2S146.65,236.23,146.65,236.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.35,243.06a3.66,3.66,0,0,1-.39-.21c-.25-.14-.61-.37-1.1-.62a27.55,27.55,0,0,0-4.26-1.84,46.37,46.37,0,0,0-6.66-1.71c-2.55-.49-5.38-.86-8.35-1.28l-15.2-2.15-4.61-.68-1.25-.19-.43-.08.44,0,1.25.16,4.62.61,15.21,2.1c3,.42,5.8.8,8.35,1.3a45.4,45.4,0,0,1,6.68,1.75,27.39,27.39,0,0,1,4.25,1.91C237.85,242.71,238.35,243.06,238.35,243.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.58,253.18l-1,.45c-.66.29-1.62.7-2.88,1.2-2.52,1-6.2,2.38-10.86,3.74a118,118,0,0,1-16.62,3.67,116.22,116.22,0,0,1-20.82.73c-7.39-.24-14.44-.56-20.83-.16a64,64,0,0,0-16.68,3,41.46,41.46,0,0,0-10.26,5c-1.1.8-2,1.42-2.48,1.89s-.85.69-.85.69l.82-.72c.53-.48,1.37-1.11,2.47-1.92a41,41,0,0,1,10.25-5.1,64.6,64.6,0,0,1,16.72-3.09c6.4-.41,13.46-.09,20.85.15a116.9,116.9,0,0,0,20.79-.71,119.8,119.8,0,0,0,16.6-3.63c4.66-1.34,8.34-2.7,10.87-3.68,1.26-.49,2.24-.89,2.89-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.64,262.15l-.16.07-.49.18c-.41.16-1,.35-1.8.58a24.09,24.09,0,0,1-6.17.94,21.26,21.26,0,0,1-6.17-.89c-.77-.23-1.38-.44-1.79-.61l-.48-.19c-.11,0-.16-.07-.16-.08l.17.05.49.15c.42.15,1,.34,1.81.55a22.78,22.78,0,0,0,6.13.83,26.4,26.4,0,0,0,6.14-.88l1.81-.52.49-.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.73,288.08s-4.4.93-11.58,2c-3.59.54-7.88,1.07-12.66,1.55s-10,.83-15.57,1-10.82.19-15.62.09-9.12-.35-12.74-.63c-7.24-.55-11.69-1.16-11.69-1.16l.82.07,2.32.23c2,.22,4.94.47,8.56.72s7.94.48,12.73.59,10.08.09,15.61-.1,10.79-.58,15.57-1,9.06-1,12.65-1.51,6.49-1,8.49-1.34l2.3-.4C202.45,288.11,202.73,288.08,202.73,288.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.62,285.48l-.33,0-1,0c-.83,0-2,0-3.51,0-3,0-7.08-.12-11.59-.5s-8.58-1-11.51-1.53c-1.46-.27-2.64-.5-3.45-.67l-.93-.21-.32-.08.33,0,.94.17,3.46.62c2.92.49,7,1.07,11.49,1.47s8.61.51,11.58.55l3.51,0h1A2.06,2.06,0,0,1,238.62,285.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.83,323.26l-.75.12-2.16.3c-.94.14-2.09.29-3.43.38s-2.87.28-4.56.31-3.55.15-5.55.12c-1,0-2,0-3.08,0l-3.28-.11c-4.47-.18-9.39-.52-14.54-1s-10.06-.88-14.53-1.18-8.5-.46-11.88-.41h-2.42l-2.15.11c-1.34.05-2.5.11-3.44.23l-2.17.22-.76.06.76-.1,2.16-.25c.94-.13,2.1-.2,3.45-.27l2.15-.12,2.42,0c3.39-.07,7.42.11,11.9.38s9.37.73,14.53,1.16,10.06.8,14.53,1l3.27.11c1.06,0,2.09,0,3.08,0,2,0,3.85-.05,5.54-.1s3.22-.2,4.56-.28,2.49-.22,3.43-.34l2.17-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.79,312.5a3.92,3.92,0,0,1-.4.06l-1.17.12c-1,.11-2.48.23-4.3.36-3.64.24-8.68.42-14.25.28s-10.59-.59-14.21-1c-1.81-.22-3.27-.42-4.28-.58l-1.16-.19a3.62,3.62,0,0,1-.4-.08l.41,0,1.16.15c1,.14,2.48.32,4.29.52,3.62.41,8.64.83,14.2,1s10.59,0,14.23-.23c1.82-.1,3.29-.21,4.3-.29l1.17-.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.44,345.81l-1.33-.08c-.88,0-2.17-.18-3.84-.23-3.34-.17-8.17-.21-14.13.09s-13,1-20.87,2-16.4,2.36-25.44,3.52a221.94,221.94,0,0,1-25.61,1.95,117.37,117.37,0,0,1-20.9-1.52,84.41,84.41,0,0,1-13.71-3.45c-.79-.25-1.49-.52-2.08-.76l-1.51-.6-1.25-.5s.44.15,1.26.46l1.52.59c.6.23,1.29.49,2.09.74a85.53,85.53,0,0,0,13.7,3.39,118.55,118.55,0,0,0,20.88,1.47,221.9,221.9,0,0,0,25.59-2c9-1.16,17.61-2.5,25.44-3.51s14.91-1.72,20.88-2a137.28,137.28,0,0,1,14.14,0C245.61,345.61,247.44,345.81,247.44,345.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,380s-4.4.75-11.59,1.52c-3.59.39-7.87.74-12.64,1s-10,.4-15.53.37-10.76-.28-15.53-.59-9.05-.75-12.63-1.2c-7.17-.87-11.57-1.68-11.57-1.68l.81.1,2.3.34c1,.15,2.22.33,3.64.51s3,.41,4.83.6c3.59.42,7.87.82,12.63,1.15s10,.53,15.52.58,10.75-.12,15.52-.36,9-.59,12.64-1c1.8-.16,3.42-.37,4.84-.53s2.65-.32,3.65-.46l2.31-.3C196.77,380.05,197,380,197,380Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.89,373.47l-.49.16-1.4.42c-1.23.37-3,.88-5.21,1.47-4.42,1.18-10.56,2.65-17.42,3.91s-13.14,2.06-17.68,2.52c-2.28.23-4.12.39-5.39.48l-1.47.1-.51,0,.51-.06,1.46-.13c1.27-.11,3.11-.3,5.38-.54,4.54-.5,10.8-1.33,17.66-2.58s13-2.71,17.42-3.85c2.21-.58,4-1.06,5.23-1.41l1.41-.39C246.72,373.5,246.89,373.47,246.89,373.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.08,418.24a65.9,65.9,0,0,1-7.13.7,77,77,0,0,1-7.78,0,90.54,90.54,0,0,1-9.48-1,87,87,0,0,1-9.29-2.13c-2.81-.83-5.3-1.7-7.35-2.54a66,66,0,0,1-6.52-3l.46.2,1.29.6c.56.27,1.24.59,2.06.92s1.72.76,2.76,1.14c2.05.82,4.55,1.68,7.35,2.5a89.83,89.83,0,0,0,9.27,2.11,93.26,93.26,0,0,0,9.46,1c2.92.13,5.55.14,7.76,0,1.11,0,2.11-.12,3-.18s1.63-.13,2.25-.2l1.42-.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,415.9s-.31.07-.91.16l-2.62.42c-2.27.37-5.57.87-9.65,1.45-8.16,1.17-19.46,2.61-32,3.85s-23.88,2-32.11,2.5c-4.11.23-7.44.39-9.75.48l-2.65.1-.92,0,.92-.06,2.65-.14,9.74-.54c8.23-.5,19.59-1.32,32.1-2.56s23.81-2.66,32-3.8l9.66-1.38,2.63-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.94,261.33s-.26.73-.86,2a37.17,37.17,0,0,1-3,5.1,65.51,65.51,0,0,1-5.52,6.84c-2.22,2.45-4.77,5-7.35,7.84a67.19,67.19,0,0,0-6.69,8.38,34.83,34.83,0,0,0-3.94,7.8,24.49,24.49,0,0,0-1.27,5.75c-.09.7-.06,1.24-.09,1.61s0,.56,0,.56a19.64,19.64,0,0,1,.06-2.17,23.22,23.22,0,0,1,1.21-5.79,34.73,34.73,0,0,1,3.92-7.85,65.26,65.26,0,0,1,6.7-8.42c2.59-2.8,5.14-5.39,7.36-7.83a69.77,69.77,0,0,0,5.54-6.79,38.24,38.24,0,0,0,3-5.07c.33-.61.52-1.12.69-1.45S281.94,261.33,281.94,261.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.73,277.12l.31-.22.91-.62c.8-.53,1.93-1.34,3.28-2.38s2.93-2.35,4.59-3.88a68.94,68.94,0,0,0,5.09-5.31,72.6,72.6,0,0,0,4.44-5.87c1.25-1.89,2.3-3.63,3.11-5.14s1.43-2.75,1.82-3.62l.47-1c.11-.23.17-.34.17-.34a50.19,50.19,0,0,1-2.35,5,59.92,59.92,0,0,1-3.08,5.18,64.94,64.94,0,0,1-4.44,5.89,65.7,65.7,0,0,1-5.11,5.32c-1.67,1.53-3.25,2.83-4.62,3.86A49.41,49.41,0,0,1,239.73,277.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.22,320l.22-.11.66-.25c.59-.2,1.43-.57,2.51-1.07a32.91,32.91,0,0,0,8.11-5.77A64,64,0,0,0,195,301.27a161.67,161.67,0,0,0,9.05-15.77,273.12,273.12,0,0,0,12.85-30.44c1.45-4,2.57-7.22,3.35-9.46.39-1.09.69-1.95.91-2.57l.24-.66c.06-.15.09-.23.1-.22a.82.82,0,0,1-.05.23c-.06.18-.12.4-.21.68-.19.63-.47,1.5-.82,2.6-.73,2.25-1.81,5.51-3.21,9.51a254.61,254.61,0,0,1-12.75,30.54,160.23,160.23,0,0,1-9.1,15.8A63.75,63.75,0,0,1,185.94,313a31.75,31.75,0,0,1-8.26,5.69,24.34,24.34,0,0,1-2.54,1l-.68.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.69,339.38a2.73,2.73,0,0,1,.5-.38l1.48-1c1.28-.9,3.12-2.21,5.34-3.91,4.44-3.38,10.28-8.43,16.55-14.2,3.15-2.87,6.17-5.59,8.77-8.2a68,68,0,0,0,6.47-7.34,41.24,41.24,0,0,0,3.54-5.56c.38-.68.62-1.24.81-1.6a4.17,4.17,0,0,1,.3-.56,2.72,2.72,0,0,1-.22.6c-.16.37-.37.94-.73,1.64a37.09,37.09,0,0,1-3.44,5.67,64.47,64.47,0,0,1-6.43,7.45c-2.6,2.63-5.61,5.37-8.76,8.24a214.93,214.93,0,0,1-16.67,14.12c-2.24,1.67-4.12,2.94-5.43,3.79-.66.43-1.18.74-1.53,1A3.31,3.31,0,0,1,172.69,339.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,437.37s0-.08.11-.21.21-.35.36-.58c.32-.51.82-1.25,1.48-2.18,1.32-1.86,3.37-4.46,6.07-7.53,5.43-6.1,13-14.42,21.42-23.62L199,379.73l6.57-7.09,1.81-1.91.47-.49a1,1,0,0,1,.18-.16,1,1,0,0,1-.14.19l-.44.52-1.74,2L199.19,380l-21.45,23.61-21.52,23.52c-2.72,3-4.8,5.6-6.17,7.43-.68.91-1.2,1.63-1.54,2.12l-.4.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.52,272.64a9.59,9.59,0,0,1-.35-1.4,16.82,16.82,0,0,1-.29-1.66c-.08-.65-.21-1.39-.26-2.22s-.13-1.73-.13-2.7,0-2,.08-3.11A40.14,40.14,0,0,1,236,247.77c.47-1,.9-1.94,1.39-2.78s.93-1.63,1.38-2.33.89-1.3,1.27-1.84a15.36,15.36,0,0,1,1-1.33,9.45,9.45,0,0,1,1-1.07,8.43,8.43,0,0,1-.81,1.18c-.28.37-.62.82-1,1.37s-.8,1.15-1.2,1.86-.89,1.48-1.33,2.34-.88,1.79-1.34,2.77A42,42,0,0,0,233,261.58c-.06,1.08-.14,2.11-.12,3.08s0,1.86.08,2.68.13,1.56.19,2.21.13,1.21.21,1.66A8.56,8.56,0,0,1,233.52,272.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.85,305.52c-.11.05-1.76-3.59-3.68-8.14a86.1,86.1,0,0,1-3.26-8.31c.11-.05,1.76,3.59,3.68,8.13A85.64,85.64,0,0,1,246.85,305.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.83,276.46c-.07,0-.79-1.27-2.14-3.26a45.64,45.64,0,0,0-13.35-13c-2-1.29-3.36-2-3.33-2a5.16,5.16,0,0,1,1,.41c.62.28,1.48.74,2.53,1.35a40.67,40.67,0,0,1,7.49,5.75,41.42,41.42,0,0,1,6,7.31c.64,1,1.13,1.88,1.42,2.48A5.7,5.7,0,0,1,115.83,276.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.84,254.79a3.06,3.06,0,0,1,0-.94,7.44,7.44,0,0,1,.56-2.21,7.21,7.21,0,0,1,1.54-2.33l0-.05,0,.06a2.17,2.17,0,0,1,.14.4s-.1-.12-.23-.36H154a9.15,9.15,0,0,0-1.44,2.34A11.5,11.5,0,0,0,151.84,254.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,261.08a3.39,3.39,0,0,1-.19-.91,8.82,8.82,0,0,1,.06-2.26,8.24,8.24,0,0,1,.63-2.16,3.23,3.23,0,0,1,.46-.82,14.71,14.71,0,0,0-.9,3A15.48,15.48,0,0,0,164,261.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.2,260a14.11,14.11,0,0,0-.35-2.55,15.32,15.32,0,0,0-1-2.37,2.27,2.27,0,0,1,.45.62,6.56,6.56,0,0,1,.72,1.7,6.77,6.77,0,0,1,.25,1.83A2.28,2.28,0,0,1,177.2,260Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.77,255a14.4,14.4,0,0,0-1.38-2.33,14,14,0,0,0-1.93-1.9,2.3,2.3,0,0,1,.69.42,7,7,0,0,1,1.39,1.36,7.41,7.41,0,0,1,1,1.68A2.59,2.59,0,0,1,188.77,255Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.73,247.11a5.09,5.09,0,0,0-4.28-3.7h.24a3.05,3.05,0,0,1,.65.08,4.56,4.56,0,0,1,1.93,1,4.43,4.43,0,0,1,1.26,1.77,3,3,0,0,1,.18.63A.55.55,0,0,1,196.73,247.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,232.6a5.83,5.83,0,0,0-2.41-1.15,6,6,0,0,0-2.66.21,3.81,3.81,0,0,1,2.7-.4A3.75,3.75,0,0,1,201,232.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.88,245a2.21,2.21,0,0,1,.2-.78,5.19,5.19,0,0,1,1-1.66,5.32,5.32,0,0,1,1.56-1.17,2.18,2.18,0,0,1,.77-.25,7.39,7.39,0,0,0-2.19,1.55A7.83,7.83,0,0,0,143.88,245Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,235.35a2.74,2.74,0,0,1,.45-.74,6.79,6.79,0,0,1,1.54-1.43,6.59,6.59,0,0,1,1.9-.89,2.9,2.9,0,0,1,.86-.15,10.57,10.57,0,0,0-2.66,1.2A11.18,11.18,0,0,0,141,235.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.21,291.68s0-.05-.06,0a.94.94,0,0,0-.08.3q-.07.42-.15,1.23c-.11,1.07-.23,2.63-.36,4.56-.26,3.86-.57,9.2-.85,15.1s-.5,11.24-.63,15.11c-.06,1.87-.11,3.42-.15,4.58,0,.49,0,.9-.05,1.24a2.19,2.19,0,0,1,0,.44,1.18,1.18,0,0,1,0-.44c0-.34,0-.75,0-1.24,0-1.09,0-2.65,0-4.59,0-3.87.2-9.22.49-15.12s.64-11.24,1-15.1c.18-1.93.35-3.49.51-4.56A11.65,11.65,0,0,1,118,292a.76.76,0,0,1,.13-.31C118.2,291.58,118.22,291.7,118.21,291.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.19,106.55c-7.65-2.33-15.62,4.51-23.46,3-4.77-.93-8.36-4.74-12.6-7.11-6.34-3.54-15.3-4.11-21.78-.82s-10.64,6.8-11.52,14c-5.9-3.38-15.73,4-19.07,11.19s-2.51,14.56-.61,22.22a104.21,104.21,0,0,0,17.24,36.7c.72,1,1.86,2,3,1.53a2.63,2.63,0,0,0,1.13-2.11c1.13-7,.24-14.17-.37-21.25s-.9-14.37,1.33-21.11,7.51-12.9,14.48-14.27c5.15-1,10.49.66,15.07,3.22s8.59,6,13,8.93,9.25,5.39,14.49,5.62,10.86-2.25,13.1-7-.27-11.5-5.41-12.58a10.32,10.32,0,0,0,2.08-20.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.61,229.51l-.75-15.18s20-3.83,19.55-24c-.22-9.71-2.3-29.68-4.4-47.73a37.49,37.49,0,0,0-38.55-33.15l-1.94.07c-20.88,2-30.88,20.78-28.35,41.59l4.81,81a24.85,24.85,0,0,0,26.12,23.34h0A24.86,24.86,0,0,0,195.61,229.51Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.89,214.32s-12.67,1.48-26.48-6.54c0,0,6.71,14.26,26.71,11.74Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.45,156.29a2.87,2.87,0,0,1-2.67,3,2.75,2.75,0,0,1-3.05-2.48,2.88,2.88,0,0,1,2.67-3A2.74,2.74,0,0,1,205.45,156.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,152.63c-.34.39-2.57-1.14-5.66-1s-5.3,1.75-5.65,1.38c-.17-.16.17-.85,1.13-1.61a7.9,7.9,0,0,1,4.51-1.56,7.55,7.55,0,0,1,4.52,1.29C205.86,151.79,206.2,152.46,206,152.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75,157.66a2.87,2.87,0,0,1-2.67,3,2.75,2.75,0,0,1-3.05-2.49,2.87,2.87,0,0,1,2.66-3A2.76,2.76,0,0,1,175.75,157.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.68,154.28c-.34.38-2.58-1.15-5.66-1s-5.3,1.74-5.65,1.37c-.17-.16.16-.85,1.13-1.6a7.89,7.89,0,0,1,4.5-1.57,7.65,7.65,0,0,1,4.53,1.29C175.5,153.44,175.85,154.1,175.68,154.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7,176.8c0-.18,1.89-.58,5-1.08.78-.11,1.52-.29,1.64-.84a4.13,4.13,0,0,0-.61-2.32l-2.55-5.93c-3.54-8.44-6.13-15.39-5.79-15.53s3.49,6.59,7,15c.86,2.08,1.67,4.07,2.45,6a4.56,4.56,0,0,1,.52,3.08,2,2,0,0,1-1.26,1.2,5.09,5.09,0,0,1-1.33.23C189.66,176.89,187.72,177,187.7,176.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.73,187.6c-.42.27-2.09-2.64-5.77-3.28s-6.59,1.46-6.85,1.06c-.14-.16.37-1,1.66-1.74a8.3,8.3,0,0,1,5.62-1,7.27,7.27,0,0,1,4.66,2.85C189.85,186.59,189.94,187.5,189.73,187.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69,146.25c.17-.88,3.28-.95,6.8-1.94s6.27-2.4,6.86-1.73c.27.32-.12,1.18-1.16,2.17a12.26,12.26,0,0,1-10.41,2.79C162.38,147.21,161.62,146.66,161.69,146.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.35,142.27c.67-.58,2.62.56,5.12,1.1s4.73.47,5.08,1.29c.14.39-.33,1-1.39,1.48a7.29,7.29,0,0,1-4.4.28,7.21,7.21,0,0,1-3.82-2.2C196.2,143.33,196.05,142.56,196.35,142.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.33,166c-.35-.13-14-3.6-13,10.13s14.52,10,14.52,9.58S143.33,166,143.33,166Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.27,180.78c-.07,0-.23.19-.62.4a2.4,2.4,0,0,1-1.79.16c-1.49-.44-2.86-2.66-3.1-5.13a8.14,8.14,0,0,1,.44-3.47,2.81,2.81,0,0,1,1.68-2,1.23,1.23,0,0,1,1.46.56c.21.37.14.65.21.67s.28-.25.13-.81a1.49,1.49,0,0,0-.6-.82,1.77,1.77,0,0,0-1.34-.26,3.36,3.36,0,0,0-2.36,2.3,8.19,8.19,0,0,0-.57,3.88c.27,2.76,1.86,5.25,3.89,5.69a2.52,2.52,0,0,0,2.16-.51C140.26,181.12,140.31,180.8,140.27,180.78Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.12,138.29a29,29,0,0,1-26-4.91c-5-4-9-9.8-15.22-11.47a16.32,16.32,0,0,0-12.43,2.14,31.55,31.55,0,0,0-9.16,9c4.24,10.08,2,21.58-.24,32.28a5.49,5.49,0,0,1-1.49,3.23c-1.58,1.3-4.05.41-5.52-1-2.35-2.3-3.35-5.62-4.05-8.83a56.84,56.84,0,0,1-.65-22.31,38.62,38.62,0,0,1,9.9-19.8,36.54,36.54,0,0,1,25.25-10.57,44.87,44.87,0,0,1,26.3,8.38c3.55,2.49,6.85,5.54,8.78,9.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.13,111.2a3.09,3.09,0,0,1-.08,1.19,5.59,5.59,0,0,1-1.82,2.9,8.73,8.73,0,0,1-5.08,1.9,15.26,15.26,0,0,1-3.42-.09,7.41,7.41,0,0,1-3.56-1.5,4.85,4.85,0,0,1-1.85-3.82,4.27,4.27,0,0,1,2.79-3.62,5.39,5.39,0,0,1,2.46-.4,4.47,4.47,0,0,1,2.4,1,6.28,6.28,0,0,1,2.22,4.73,7.24,7.24,0,0,1-2,5.12,11.07,11.07,0,0,1-4.88,3c-3.78,1.19-8,.61-11.8-.86A51.75,51.75,0,0,1,190.14,115a64.77,64.77,0,0,0-9.42-5.56,20.43,20.43,0,0,0-9.53-2,19.55,19.55,0,0,0-8.15,2.4,24.41,24.41,0,0,0-8.83,8.61c-.78,1.26-1.3,2.28-1.65,3s-.51,1.08-.53,1.07,0-.11.08-.29.17-.47.33-.83a25.45,25.45,0,0,1,1.54-3.06,24,24,0,0,1,8.83-8.9,19.74,19.74,0,0,1,8.34-2.54,20.82,20.82,0,0,1,9.82,2,64.63,64.63,0,0,1,9.54,5.58,51.7,51.7,0,0,0,10.26,5.68,17.52,17.52,0,0,0,11.35.87,10.42,10.42,0,0,0,4.6-2.81,6.62,6.62,0,0,0,1.84-4.66,5.68,5.68,0,0,0-2-4.28,4.12,4.12,0,0,0-4.27-.52,3.71,3.71,0,0,0-2.49,3.11,4.39,4.39,0,0,0,1.64,3.43,7,7,0,0,0,3.32,1.44,15.07,15.07,0,0,0,3.32.14,8.54,8.54,0,0,0,4.93-1.72,5.61,5.61,0,0,0,1.86-2.73A10,10,0,0,0,225.13,111.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.72,138.71a23.18,23.18,0,0,0,4.24.94,11.69,11.69,0,0,0,4.59-.64,19.81,19.81,0,0,0,5.07-2.66,16.05,16.05,0,0,0,5.83-8.4,35,35,0,0,0,.77-4.3,3.67,3.67,0,0,1,.11,1.19,13.6,13.6,0,0,1-.41,3.23,15.66,15.66,0,0,1-5.9,8.83,19.35,19.35,0,0,1-5.28,2.71,11.51,11.51,0,0,1-4.82.52,10.89,10.89,0,0,1-3.16-.84A3.74,3.74,0,0,1,128.72,138.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.67,148.64c0-.13,1.63.17,4.22-.07a18.83,18.83,0,0,0,15.67-11.16c1.07-2.37,1.31-4,1.44-4a3.45,3.45,0,0,1-.11,1.15,16.08,16.08,0,0,1-.89,3,18.24,18.24,0,0,1-16.07,11.46,16.31,16.31,0,0,1-3.14-.15A3.7,3.7,0,0,1,129.67,148.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.88,167.77a.35.35,0,0,1-.42-.28.34.34,0,1,1,.42.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.73,166.23a.4.4,0,0,1-.43-.34.41.41,0,0,1,.23-.5.39.39,0,0,1,.43.34A.4.4,0,0,1,171.73,166.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7,166c-.18,0-.37-.19-.42-.5s.06-.57.25-.6.37.19.42.49S175.89,166,175.7,166Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.91,171.38c-.19,0-.35-.09-.35-.21s.14-.22.33-.23.35.09.35.21S169.1,171.37,168.91,171.38Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.28,169.93a.37.37,0,0,1-.39-.34.39.39,0,0,1,.29-.43.37.37,0,0,1,.39.35A.37.37,0,0,1,174.28,169.93Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.34,165.58a.39.39,0,0,1-.18-.75.37.37,0,0,1,.42.3A.36.36,0,0,1,202.34,165.58Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.35,165.07a.4.4,0,0,1-.4-.38.39.39,0,0,1,.28-.47.39.39,0,0,1,.4.38A.4.4,0,0,1,206.35,165.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.79,165.8a.31.31,0,0,1-.4-.21.32.32,0,0,1,.26-.37.33.33,0,0,1,.4.21A.32.32,0,0,1,198.79,165.8Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.91,169.72a.38.38,0,0,1-.48-.2.38.38,0,0,1,.14-.51.4.4,0,0,1,.34.71Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.32,168.92a.32.32,0,0,1-.26-.36.34.34,0,0,1,.66.15A.32.32,0,0,1,205.32,168.92Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,351.23c-1-.5-4.59-.23-8.54.27,5.76-1.48,8-3.25,7.8-4.75-.39-2.57-13.86-.5-20.13.61,5.17-1,15.05-2.94,17.16-4,2.89-1.5-.73-3-4.08-3.45-3.77-.47-26-.06-32.45-.28-4.42-.14-4.09-4-4.09-4,2-9.11-1.25-17.29-3.18-19.09s-5,.25-4.45,3.1c.47,2.31.1,6.4-.3,9.45a22.62,22.62,0,0,1-2.21,7.21c-.77,1.5-1.49,2.85-2.19,4.07l-68.92,14.35,6.79-20.79L72.8,321.24,57.08,362.35a32.71,32.71,0,0,0,10.4,37.45h0A32.71,32.71,0,0,0,98.14,405l91.06-29.39L222.39,363c8.31-2.86,11.54-4.63,10.9-6.15-.85-2-.43-1.28-16.28,1.77C217,358.65,239.6,354.09,233.93,351.23Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.66,361.15c.07.4,5-.34,11-1.64s10.74-2.69,10.64-3.08-5,.34-11,1.64S208.59,360.75,208.66,361.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.1,354.33c.06.4,5.33-.09,11.76-1.09s11.61-2.15,11.54-2.55-5.33.09-11.76,1.09S205,353.93,205.1,354.33Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.38,348.5c.06.4,5.05,0,11.15-.85s11-1.9,10.95-2.31-5,0-11.15.85S202.33,348.09,202.38,348.5Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.86,354.63a4.77,4.77,0,0,1-1,.55l-2.65,1.37c-2.25,1.14-5.33,2.76-8.67,4.66s-6.32,3.71-8.45,5.05l-2.54,1.58a4.44,4.44,0,0,1-1,.53,4.23,4.23,0,0,1,.85-.7c.56-.42,1.4-1,2.44-1.72,2.09-1.42,5-3.29,8.4-5.2s6.47-3.47,8.77-4.53c1.14-.54,2.07-1,2.73-1.22A4.44,4.44,0,0,1,108.86,354.63Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.94,243.32a43.62,43.62,0,0,1,12.81-3.23c5.62-.69,12-.64,16.05,3.33,3.8,3.73,4.48,10,8.77,13.19,3.31,2.44,7.78,2.27,11.87,2.77a36.75,36.75,0,0,1,23.12,12.89A46.85,46.85,0,0,1,443.9,296.9c1.26,10.51-.41,21.93,4.92,31.07,4.75,8.15,14,12.51,23.12,15.07-5.65,9.14-37.54,28.57-47.51,32.6l-9.32-78.28s-36.61-42.22-49.56-41.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360.94,243.32a43.62,43.62,0,0,1,12.81-3.23c5.62-.69,12-.64,16.05,3.33,3.8,3.73,4.48,10,8.77,13.19,3.31,2.44,7.78,2.27,11.87,2.77a36.75,36.75,0,0,1,23.12,12.89A46.85,46.85,0,0,1,443.9,296.9c1.26,10.51-.41,21.93,4.92,31.07,4.75,8.15,14,12.51,23.12,15.07-5.65,9.14-37.54,28.57-47.51,32.6l-9.32-78.28s-36.61-42.22-49.56-41.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M443.17,292.48a1.1,1.1,0,0,1-.12.28,4.9,4.9,0,0,1-.46.77,9.56,9.56,0,0,1-2.31,2.32,12,12,0,0,1-4.47,1.92,27.43,27.43,0,0,1-5.92.4c-2.09,0-4.08-.12-5.87,0a20.1,20.1,0,0,0-4.69.75,15.2,15.2,0,0,0-3.93,1.93s.06-.1.21-.24a6.9,6.9,0,0,1,.69-.56,10.82,10.82,0,0,1,2.92-1.48,18.8,18.8,0,0,1,4.77-.88c1.83-.13,3.83-.05,5.91,0a29.15,29.15,0,0,0,5.82-.35,12,12,0,0,0,4.35-1.76A12.83,12.83,0,0,0,443.17,292.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,316.09a5.11,5.11,0,0,1-.94.7,12.55,12.55,0,0,1-1.17.72c-.47.26-1,.58-1.6.86a30.11,30.11,0,0,1-4.4,1.78,32.48,32.48,0,0,1-11.47,1.49,30.22,30.22,0,0,1-4.71-.6c-.66-.11-1.25-.29-1.77-.42a12.51,12.51,0,0,1-1.31-.4,4.78,4.78,0,0,1-1.09-.44c0-.09,1.61.44,4.24.9a33.87,33.87,0,0,0,4.66.48,37.78,37.78,0,0,0,5.71-.26,37.16,37.16,0,0,0,5.6-1.21,34.25,34.25,0,0,0,4.38-1.65C443.58,316.93,445,316,445,316.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.77,337c0,.05-.55,0-1.51.17a10.75,10.75,0,0,0-3.84,1.39,30.4,30.4,0,0,0-4.85,3.74,58.07,58.07,0,0,1-5.78,4.92A25.22,25.22,0,0,1,435,350.6a20.14,20.14,0,0,1-6.14.95,15.9,15.9,0,0,1-4.15-.58,11.07,11.07,0,0,1-1.08-.38,1.07,1.07,0,0,1-.36-.17,21.59,21.59,0,0,0,5.59.76,20.47,20.47,0,0,0,6-1,25.91,25.91,0,0,0,6.66-3.36,61.73,61.73,0,0,0,5.76-4.86,28.73,28.73,0,0,1,5-3.7,10.24,10.24,0,0,1,4-1.27,7.58,7.58,0,0,1,1.14,0C457.64,337,457.77,337,457.77,337Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.56,272.27a1.25,1.25,0,0,1-.09.33,6.08,6.08,0,0,1-.39.91,8.41,8.41,0,0,1-2.36,2.73,14,14,0,0,1-4.84,2.29,34,34,0,0,1-6.46,1c-2.3.19-4.49.34-6.44.7a19.56,19.56,0,0,0-5,1.57,14.24,14.24,0,0,0-3.86,2.89,1.15,1.15,0,0,1,.18-.3,6.39,6.39,0,0,1,.62-.75,11.24,11.24,0,0,1,2.89-2.17,18.69,18.69,0,0,1,5.07-1.71,58.25,58.25,0,0,1,6.49-.75,36.11,36.11,0,0,0,6.37-1A14.42,14.42,0,0,0,430.5,276a9,9,0,0,0,2.4-2.54C433.34,272.69,433.51,272.25,433.56,272.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,272.29s.08.06.24.1a.9.9,0,0,0,.67-.16,5.21,5.21,0,0,0,.91-.78l1.18-1.11a75.35,75.35,0,0,1,7.19-6.06,27,27,0,0,1,8.43-4.19,16,16,0,0,1,2.82-.51,3.05,3.05,0,0,1,1.05,0c0,.09-1.49.17-3.77.88a29.57,29.57,0,0,0-8.23,4.25c-3,2.12-5.42,4.36-7.24,5.92L393,271.67a5,5,0,0,1-1,.74,1,1,0,0,1-.81.08C391,272.4,390.94,272.29,391,272.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.57,246.15a3.46,3.46,0,0,1-.67.93,12.74,12.74,0,0,1-2.3,2.12,11.93,11.93,0,0,1-4.21,2,14.75,14.75,0,0,1-5.69-.05,37.63,37.63,0,0,0-5.54-.7,22.55,22.55,0,0,0-4.52.35c-2.56.48-4.05,1.14-4.08,1.05a3.58,3.58,0,0,1,1-.5,19.19,19.19,0,0,1,3-.91,21.32,21.32,0,0,1,4.61-.47,35.08,35.08,0,0,1,5.62.66,14.58,14.58,0,0,0,5.49.1,11.9,11.9,0,0,0,4.11-1.79A24.2,24.2,0,0,0,390.57,246.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.94,252.15c-7-1.9-12.15-4-19.29-4.31l-77.42,9.92L282.18,311s25.7,52.53,30.58,58.89c9.13,11.91-23,60.95-22,68.5H429.44s-1.36-105.71-9.6-154.51c-1.44-8.57-6.35-17.43-12.87-22.09A65.76,65.76,0,0,0,386.94,252.15Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.83,412.44a2.69,2.69,0,0,1-.44-.37l-1.2-1.16c-1-1-2.53-2.45-4.4-4.22-3.74-3.53-9.05-8.27-15.21-13.14s-12-8.93-16.33-11.75c-2.15-1.41-3.91-2.53-5.13-3.29l-1.4-.9a2.82,2.82,0,0,1-.46-.34,2.5,2.5,0,0,1,.52.25l1.45.81c1.25.71,3,1.79,5.22,3.16a194.78,194.78,0,0,1,31.6,24.93c1.84,1.81,3.3,3.3,4.29,4.35l1.12,1.22A2.33,2.33,0,0,1,366.83,412.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,302.57c-1.13-.88-1.17-2.73-.07-4.14s2.9-1.82,4-.94,1.17,2.74.07,4.15S358.84,303.46,357.71,302.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.43,259.38c-.69,1.26-1.94,1.91-2.8,1.44s-1-1.87-.31-3.13,1.94-1.91,2.8-1.44S387.11,258.12,386.43,259.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,320.6a2.17,2.17,0,1,1,2.73-2A2.4,2.4,0,0,1,375.12,320.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.09,298.81a2.55,2.55,0,1,1,.69-3.58A2.58,2.58,0,0,1,339.09,298.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.82,349.68c-1.3-.63-1.67-2.53-.83-4.26s2.56-2.62,3.85-2,1.67,2.53.84,4.26S317.11,350.31,315.82,349.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.82,354.21c-1.28.65-2.71.41-3.17-.53s.19-2.21,1.48-2.86,2.71-.4,3.17.53S332.11,353.57,330.82,354.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.33,371.44a2.26,2.26,0,0,1-3.62-.21,2.31,2.31,0,0,1-.32-2.06,2.35,2.35,0,0,1,1.39-1.4,3.66,3.66,0,0,1,1.93-.2,1.86,1.86,0,0,1,1.28.7,1.9,1.9,0,0,1,.2,1.44A3.76,3.76,0,0,1,324.33,371.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.2,378.5a2.15,2.15,0,1,1-3.3-.51A2.39,2.39,0,0,1,347.2,378.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.58,425.74a2.42,2.42,0,1,1,2.25-2.74A2.52,2.52,0,0,1,311.58,425.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.88,397.75a2,2,0,0,1-.55,2,3.74,3.74,0,0,1-2.76,1,3.66,3.66,0,0,1-2.66-1.19,2,2,0,0,1-.4-2.08,3.06,3.06,0,0,1,1.4-1.46,3.53,3.53,0,0,1,1.86-.47,3.45,3.45,0,0,1,1.82.61A3.09,3.09,0,0,1,326.88,397.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.54,421a3.24,3.24,0,1,1,2.45-3.3A2.93,2.93,0,0,1,332.54,421Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.53,410.79a2.17,2.17,0,0,1-1.9.73,3.1,3.1,0,0,1-2.58-3.62,2.19,2.19,0,0,1,1.3-1.56,3.11,3.11,0,0,1,2-.09,2.64,2.64,0,0,1,1.48,1,2.67,2.67,0,0,1,.45,1.72A3.11,3.11,0,0,1,354.53,410.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.41,431.39c-1.2-.79-1.32-2.72-.26-4.3s2.87-2.21,4.07-1.41,1.31,2.72.26,4.3S356.6,432.19,355.41,431.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.37,432.74a3.24,3.24,0,1,1,4.1.17A2.93,2.93,0,0,1,385.37,432.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.51,433.38c-1.34.52-2.73.16-3.1-.8s.42-2.15,1.76-2.67,2.73-.16,3.1.8S422.85,432.86,421.51,433.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.2,161.94c-2.62,3.47-5.28,7-6.94,11s-2.25,8.65-.67,12.7c.78,2,2.05,3.78,2.46,5.87.76,4-1.77,7.74-3,11.59A19.17,19.17,0,0,0,289,220.3c3.05,4,7.61,6.65,12.35,8.33,8.77,3.11,19.83,2.67,25.83-4.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.43,154.28c1.67,8.81,14.29,12.38,15.49,21.26.52,3.81-1.32,7.58-1.21,11.43.15,5.16,3.72,9.52,5.53,14.37,3.73,10-.61,21.76-8.64,28.76s-19,9.77-29.68,9.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,159.11c-.53-4.33-5-7.05-9.28-8s-8.8-.88-12.75-2.74c-3.49-1.65-6.13-4.65-9.22-7a26.85,26.85,0,0,0-42.79,19c-.6,6.38,1.55,13.47,7,16.82,6.33,3.87,14.5,1.55,21.47-1s14.9-5.26,21.55-1.95c4,2,6.72,5.82,9.52,9.32s6.18,7,10.59,7.8,9.71-2.55,9.2-7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,268.26c-1.57-9.89-3.1-19.51-3.09-19.46s-16.12-.25-22.46-20.28c-3.15-10-5.15-26.76-6.34-40.57-1.07-12.42,4.81-28.75,17.27-29.29l39.75,3.93a7.28,7.28,0,0,1,7.55,6.35h0l10.66,93.41a21.87,21.87,0,0,1-18.87,24.17h0A21.87,21.87,0,0,1,325,268.26Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,198c-.38-.3-2.15,1.48-5,1.9s-5.12-.69-5.38-.3c-.13.18.3.75,1.3,1.27a7.35,7.35,0,0,0,4.37.66,7,7,0,0,0,3.9-1.94C309,198.78,309.15,198.12,309,198Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.82,195.51c-.4-.27-2.06,1.61-4.86,2.2s-5.15-.37-5.38,0c-.12.18.34.72,1.37,1.18a7.31,7.31,0,0,0,4.4.39,7,7,0,0,0,3.78-2.17C335.84,196.31,336,195.63,335.82,195.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.82,215c0-.16-1.81-.2-4.72-.14-.73,0-1.44,0-1.64-.48a3.76,3.76,0,0,1,.16-2.22l1.32-5.82c1.79-8.29,3-15.05,2.63-15.12s-2.05,6.59-3.85,14.87c-.42,2-.83,4-1.21,5.84a4.26,4.26,0,0,0,.05,2.9,1.85,1.85,0,0,0,1.35.88,4.65,4.65,0,0,0,1.25,0C317.05,215.42,318.84,215.16,318.82,215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.9,248.8a52.83,52.83,0,0,0,26.37-11.46c-.22.09-5.39,15.41-25.37,16.26Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.21,187.68c-.54-.63-3.08.74-6.36,1.56s-6.15.94-6.32,1.75c-.06.38.64.9,1.93,1.21a11.43,11.43,0,0,0,9.66-2.52C334.09,188.78,334.45,188,334.21,187.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.66,192.14c-.48-.66-2.48-.06-4.85-.11s-4.36-.58-4.84.08c-.22.32.08,1,.93,1.63a6.74,6.74,0,0,0,3.9,1.2,4.44,4.44,0,0,0,3.91-1.17C308.57,193.13,308.87,192.47,308.66,192.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.26,229.87c-5.47,2-6.41-.79-11.22-4.07A18.73,18.73,0,0,1,350,211c-.13-5.13,1.8-10.67-.67-15.17-3.27-6-12.4-6.55-15.7-12.48-1.92-3.45-1.35-7.91-3.44-11.26-2-3.14-5.81-4.54-9.45-5.26s-7.47-1-10.71-2.83-5.69-5.79-4.31-9.23a196.61,196.61,0,0,1,46.48,4.06c3.54.74,7.28,1.7,9.71,4.38,2.58,2.83,3.1,6.91,3.5,10.71q2.91,27.82,5.84,55.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.78,186.07a15.92,15.92,0,0,1,29-10c3.73,5.36,3.82,12.56,2.05,18.84-2.09,7.48-7.6,14.85-15.31,15.67-7.26.77-14-4.68-17.17-11.27s-3.42-14.13-3.65-21.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.08,213.55a3.69,3.69,0,0,0,.89-1.36,10.18,10.18,0,0,0,.91-4.33,19.85,19.85,0,0,0-1.18-6.46c-.78-2.35-2-4.75-3-7.34a19.35,19.35,0,0,1-1.61-7.53c.07-2.34.85-4.45,1.05-6.32a7.85,7.85,0,0,0-.55-4.41c-.47-1-1-1.31-1-1.27s.34.47.69,1.41a8.25,8.25,0,0,1,.23,4.18c-.26,1.78-1.11,3.84-1.25,6.38a19.32,19.32,0,0,0,1.6,7.88c1,2.65,2.24,5,3,7.3a20.65,20.65,0,0,1,1.32,6.18A13.07,13.07,0,0,1,384.08,213.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.62,188.87c-.06.07,1.13,1.34,3.62,2.6a18.19,18.19,0,0,0,20.32-2.73,10.07,10.07,0,0,0,2.8-3.46c-.13-.1-1.12,1.29-3.22,3a18.91,18.91,0,0,1-19.63,2.65C382,189.82,380.72,188.74,380.62,188.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,191.93a9.39,9.39,0,0,0,2.23,3,22.75,22.75,0,0,0,16.22,6.67,9.72,9.72,0,0,0,3.66-.53c0-.16-1.41,0-3.65-.12a25.77,25.77,0,0,1-15.79-6.49A35.88,35.88,0,0,0,382.13,191.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.28,221s.07-.09.18-.29a6.54,6.54,0,0,0,.44-.91,10.94,10.94,0,0,0,.81-3.79,12.83,12.83,0,0,0-1.25-6,11.76,11.76,0,0,0-5.76-5.7c-2.69-1.34-6-2.05-8.47-4.48a6.2,6.2,0,0,1-1.85-4.64,27.83,27.83,0,0,1,1-5.6,15.49,15.49,0,0,0-2.14-12.2,13.54,13.54,0,0,0-5-4.54,16.44,16.44,0,0,0-6.68-1.64c-2.3-.17-4.56-.13-6.71-.44a12.79,12.79,0,0,1-5.89-2.14,9.13,9.13,0,0,1-3.18-5,48.17,48.17,0,0,0-1.88-5.82,20.85,20.85,0,0,0-7-8.86,16.4,16.4,0,0,0-9.37-3,13.07,13.07,0,0,0-7.75,2.41,12.63,12.63,0,0,0-4,4.67,10.59,10.59,0,0,0-1.07,3.72,5.13,5.13,0,0,0,0,1.35,13.24,13.24,0,0,1,1.39-4.91,12.48,12.48,0,0,1,3.95-4.41,12.71,12.71,0,0,1,7.45-2.19,15.92,15.92,0,0,1,8.94,3,20.07,20.07,0,0,1,6.68,8.57,47.28,47.28,0,0,1,1.82,5.75,9.94,9.94,0,0,0,3.47,5.47,13.6,13.6,0,0,0,6.3,2.33c2.25.32,4.52.28,6.77.45a15.53,15.53,0,0,1,6.33,1.54,12.57,12.57,0,0,1,4.63,4.23,14.6,14.6,0,0,1,2,11.53,28.37,28.37,0,0,0-.95,5.77,7,7,0,0,0,2.11,5.18c2.69,2.6,6.12,3.25,8.74,4.53a11.2,11.2,0,0,1,5.57,5.33,12.55,12.55,0,0,1,1.35,5.77A14.06,14.06,0,0,1,381.28,221Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.18,164a2.39,2.39,0,0,0,.1-1,4.39,4.39,0,0,0-1.09-2.62,7.12,7.12,0,0,0-3.86-2.31,11,11,0,0,0-5.92.7c-2.09.74-4.19,1.94-6.56,2.78s-5.17,1.33-7.59,0-4-4-5.52-6.72a31.18,31.18,0,0,0-6-7.72,28.67,28.67,0,0,0-17-7.67,16.43,16.43,0,0,0-8.16,1.46,12.94,12.94,0,0,0-5.41,4.8,9.55,9.55,0,0,0-1.44,5.78A9.45,9.45,0,0,0,304,155.7a7.38,7.38,0,0,0,1.9,2.11,3.22,3.22,0,0,0,.85.5,10.25,10.25,0,0,1-2.45-2.79,9.44,9.44,0,0,1-1.14-4.14,9.16,9.16,0,0,1,1.48-5.41,12.32,12.32,0,0,1,5.19-4.46,15.77,15.77,0,0,1,7.78-1.3,28.16,28.16,0,0,1,16.49,7.5,30.33,30.33,0,0,1,5.87,7.5c1.57,2.66,3.15,5.52,5.89,7a7.88,7.88,0,0,0,4.28.91,14.12,14.12,0,0,0,4-.9c2.45-.91,4.51-2.13,6.52-2.88a10.6,10.6,0,0,1,5.59-.81,6.76,6.76,0,0,1,3.7,2.05,4.41,4.41,0,0,1,1.18,2.4C371.2,163.6,371.12,163.94,371.18,164Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.72,216.06a4.12,4.12,0,0,1-.28,1.05,19.55,19.55,0,0,1-1.2,2.71,20.3,20.3,0,0,1-15.67,10.53,18.73,18.73,0,0,1-3,.09,4.77,4.77,0,0,1-1.08-.13c0-.09,1.55.06,4-.28A21.06,21.06,0,0,0,384,219.66C385.2,217.52,385.64,216,385.72,216.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.12,232.45a4.51,4.51,0,0,1-1.26.11,14.17,14.17,0,0,1-3.43-.4,15.51,15.51,0,0,1-4.73-2,14.36,14.36,0,0,1-4.46-4.43,13.25,13.25,0,0,1-1.9-6,12.9,12.9,0,0,1,.64-5.09,11,11,0,0,1,1.59-3.07,7.22,7.22,0,0,1,.6-.72c.15-.15.23-.23.25-.22a15.87,15.87,0,0,0-2.09,4.12,13.36,13.36,0,0,0,1.35,10.7,14.11,14.11,0,0,0,4.28,4.29,15.67,15.67,0,0,0,4.56,2A24.36,24.36,0,0,0,340.12,232.45Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.91,190.26c0,.06-.26.23-.77.28a3,3,0,0,1-1.93-.53,2.92,2.92,0,0,1-1.15-1.64c-.13-.5-.06-.82,0-.82s.3,1.23,1.45,2A5.35,5.35,0,0,0,319.91,190.26Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.32,192c-.12-.09.39-.91.49-2s-.22-2-.08-2.09.73.84.6,2.14S311.41,192.13,311.32,192Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,190.2c-.14-.07.15-.78.13-1.69s-.3-1.61-.17-1.68.69.61.69,1.68S313.09,190.29,313,190.2Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.33,248.92c2.73,1.71,6.3,1.15,9.34.07,6.16-2.19,11.49-6.21,17.38-9s13-4.39,18.87-1.45c1.27.64,2.55,1.63,2.77,3a7.45,7.45,0,0,1-.69,3.28c-2,6.17,2.15,12.46,3.44,18.8a22.48,22.48,0,0,1-10.75,23.44c-4.61,2.58-10,3.4-15.31,3.37-10.34-.06-21-3.5-28.19-10.89a15.81,15.81,0,0,1-3.84-5.74,16.82,16.82,0,0,1-.35-7.89,42.29,42.29,0,0,1,7.19-18.05",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.33,248.92c2.73,1.71,6.3,1.15,9.34.07,6.16-2.19,11.49-6.21,17.38-9s13-4.39,18.87-1.45c1.27.64,2.55,1.63,2.77,3a7.45,7.45,0,0,1-.69,3.28c-2,6.17,2.15,12.46,3.44,18.8a22.48,22.48,0,0,1-10.75,23.44c-4.61,2.58-10,3.4-15.31,3.37-10.34-.06-21-3.5-28.19-10.89a15.81,15.81,0,0,1-3.84-5.74,16.82,16.82,0,0,1-.35-7.89,42.29,42.29,0,0,1,7.19-18.05"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M374,280.46s.33-.64.9-1.79a30.29,30.29,0,0,0,2-5,20.11,20.11,0,0,0,.82-7.93,18.38,18.38,0,0,0-1.18-4.56c-.59-1.54-1.32-3.11-1.92-4.78a19.45,19.45,0,0,1-.86-9.92,10.12,10.12,0,0,0,.21-4.2,6,6,0,0,0-2-3,9.78,9.78,0,0,0-4.86-2.15c-1.26-.19-2-.1-2-.16a1.75,1.75,0,0,1,.51-.07,7.07,7.07,0,0,1,1.5,0,9.59,9.59,0,0,1,5.07,2.07,6.32,6.32,0,0,1,2.16,3.17,10.38,10.38,0,0,1-.16,4.39,19.24,19.24,0,0,0,.88,9.66c.59,1.65,1.31,3.21,1.91,4.78a18.55,18.55,0,0,1,1.18,4.69,20.09,20.09,0,0,1-.95,8.09,27.08,27.08,0,0,1-2.21,5c-.32.56-.58,1-.77,1.27S374.06,280.47,374,280.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.7,249.53a10,10,0,0,1-1.22,1.09c-.82.67-2,1.6-3.56,2.69a76.78,76.78,0,0,1-12.82,7.26,73.66,73.66,0,0,1-14,4.63,17,17,0,0,1-4.46.39,8.68,8.68,0,0,1-1.21-.17c-.28-.06-.42-.1-.41-.12s.58.07,1.62.08a17.64,17.64,0,0,0,4.38-.54,83.74,83.74,0,0,0,13.85-4.75A85.75,85.75,0,0,0,363.71,253c1.56-1,2.79-1.94,3.64-2.55A9.46,9.46,0,0,1,368.7,249.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.54,264.74a4.31,4.31,0,0,1-.92.52c-.6.31-1.5.7-2.63,1.14A41.37,41.37,0,0,1,336.34,269a28.56,28.56,0,0,1-2.85-.4,4.55,4.55,0,0,1-1-.25c0-.09,1.49.14,3.9.28a47.85,47.85,0,0,0,18.49-2.52C357.14,265.27,358.5,264.66,358.54,264.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.29,289.66s-.24-.21-.6-.64a13.71,13.71,0,0,1-1.32-2,17.3,17.3,0,0,1-1.42-3.23,20.24,20.24,0,0,1-.87-4.24,20.45,20.45,0,0,1,.1-4.32,17.56,17.56,0,0,1,.84-3.43,13.43,13.43,0,0,1,1-2.18,3.56,3.56,0,0,1,.47-.73c.09.05-.5,1.13-1.07,3a19.91,19.91,0,0,0-.71,3.38,21.77,21.77,0,0,0-.06,4.22,22.68,22.68,0,0,0,.8,4.14,22.32,22.32,0,0,0,1.29,3.2C341.59,288.63,342.37,289.6,342.29,289.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.46,262.41a4.55,4.55,0,0,1,.83,3.19,4.66,4.66,0,0,1-1.07,3.13,30.63,30.63,0,0,0,.55-3.15A26.9,26.9,0,0,0,345.46,262.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.08,249.48a10.1,10.1,0,0,0-1,2.09,19.13,19.13,0,0,0-.55,5.6,33.53,33.53,0,0,0,1.47,7.88,7.25,7.25,0,0,1-1-2.18,20.21,20.21,0,0,1-1-5.68,16.59,16.59,0,0,1,.73-5.74A3.65,3.65,0,0,1,335.08,249.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.26,257.2a7.88,7.88,0,0,1-1.63-2,18.71,18.71,0,0,1-2.84-12,8.22,8.22,0,0,1,.55-2.53,27.06,27.06,0,0,0,.36,8.65A26.73,26.73,0,0,0,357.26,257.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.92,264.28a44,44,0,0,0,.42-4.64,46.34,46.34,0,0,0-.63-4.61,10.76,10.76,0,0,1,.21,9.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.41,286.15a2.59,2.59,0,0,1-.79-.4,12.27,12.27,0,0,1-1.95-1.46,15.65,15.65,0,0,1-4.95-14.64,13,13,0,0,1,.67-2.35,2.75,2.75,0,0,1,.39-.8c.09,0-.4,1.21-.69,3.21A16.39,16.39,0,0,0,361.92,284C363.37,285.43,364.47,286.07,364.41,286.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.66,249.48a10,10,0,0,0-.1,4.73,23.05,23.05,0,0,0,1.79,4.88,26.19,26.19,0,0,1,2.2,6.08,21.81,21.81,0,0,1-.77,11.65,20.89,20.89,0,0,1-1.49,3.23,6.66,6.66,0,0,1-.74,1.08,43.84,43.84,0,0,0,1.88-4.43,22.45,22.45,0,0,0,.61-11.42,27.59,27.59,0,0,0-2.12-6,21.63,21.63,0,0,1-1.72-5,9.11,9.11,0,0,1,0-3.57,6.2,6.2,0,0,1,.29-.93C370.59,249.58,370.64,249.48,370.66,249.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.73,281a5.34,5.34,0,0,1-.52-1.17,14.36,14.36,0,0,1-.51-1.41c-.17-.55-.39-1.18-.55-1.9a33.24,33.24,0,0,1-.89-5.09,39,39,0,0,1-.05-6.33,38.37,38.37,0,0,1,1.07-6.24A33.71,33.71,0,0,1,325,254c.27-.69.59-1.27.85-1.8a13.32,13.32,0,0,1,.72-1.31,5.81,5.81,0,0,1,.7-1.06c.09.05-.84,1.61-1.93,4.31a36.15,36.15,0,0,0-1.58,4.86,37.71,37.71,0,0,0-1,12.4,37.11,37.11,0,0,0,.77,5C324.15,279.25,324.82,280.93,324.73,281Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,343.84s-.5-10.21-3.53-14.79-19.6-24.6-19.6-24.6a4.46,4.46,0,0,0-4.87.6c-2.23,2,.11,5.51,2.09,9.26s4.6,8,4.6,8S327,291.66,323.71,293s-2.67,3-1.53,4.56S332.78,311,332.78,311,318.77,293.06,315,295s-1.51,3.23-.24,5.74S324.42,314,324.42,314s-9.81-11.43-12.2-9.24-1.53,3.05.76,6.19,7.47,10,7.47,10-4.88-2.17-6.15-.11-.08,3.28,2.87,5.58,15.28,11.63,20.08,16.56S353.36,359,353.36,359l25.5-9.73Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.36,359.05h0c-.11-.11-11.37-11.23-16.11-16.1-4.18-4.29-14.23-12-18.52-15.35l-1.55-1.2c-3-2.32-4.15-3.55-2.88-5.61.53-.85,1.76-1.1,3.58-.73a14.71,14.71,0,0,1,2.52.79c-.57-.76-5.28-7-7.42-9.92l-.38-.53c-2-2.7-2.65-3.61-.38-5.69a1.16,1.16,0,0,1,.81-.29h.1c1.38.08,3.71,1.71,6.92,4.84,1.62,1.58,3.06,3.17,3.83,4-1.87-2.4-8.05-10.37-9.11-12.49a13.46,13.46,0,0,0-.89-1.48c-.58-.88-1.09-1.64-.89-2.4s.81-1.24,2-1.89c.86-.46,2.34.1,4.38,1.65a51.21,51.21,0,0,1,5.93,5.56c1.71,1.82,3.35,3.7,4.65,5.24-2.89-3.61-7.07-8.87-7.81-9.87a3.21,3.21,0,0,1-.84-2.59c.21-.78,1-1.44,2.38-2a1,1,0,0,1,.26,0c1.72,0,7.26,4.77,16.5,14.19,6.62,6.74,13,13.7,14.11,14.95-.56-.93-2.76-4.55-4.46-7.77-.23-.43-.46-.86-.69-1.27a24,24,0,0,1-2.11-4.56c-.42-1.55-.2-2.65.71-3.46a4.5,4.5,0,0,1,4.9-.6h0c.16.2,16.59,20.09,19.6,24.61s3.52,14.51,3.54,14.79l2.83,5.47h0Zm-37-39.12a2.25,2.25,0,0,0-2,.87,2.36,2.36,0,0,0-.14,2.68,12.48,12.48,0,0,0,3,2.87l1.55,1.2c4.29,3.31,14.34,11.06,18.53,15.36,4.67,4.8,15.68,15.67,16.1,16.09l25.45-9.72-2.8-5.44c0-.1-.54-10.26-3.54-14.77s-19.27-24.22-19.59-24.6a4.47,4.47,0,0,0-4.84.6c-.89.8-1.11,1.88-.69,3.4a24,24,0,0,0,2.11,4.56c.22.41.46.84.68,1.27,2,3.7,4.58,7.95,4.61,8l0,0C354.44,322,328.1,293,324,293a.61.61,0,0,0-.24,0c-1.37.57-2.14,1.22-2.36,2a3.19,3.19,0,0,0,.84,2.54c.92,1.26,7.3,9.24,9.69,12.23l.91,1.13h0l0,0-.91-1.13c-1.3-1.6-3.83-4.66-6.56-7.56-3.26-3.47-7.4-7.35-9.6-7.35a1.29,1.29,0,0,0-.66.15c-1.22.64-1.86,1.23-2,1.86s.29,1.45.89,2.35a15.43,15.43,0,0,1,.9,1.49c1.24,2.48,9.55,13.06,9.64,13.16l0,0c-.08-.1-8-9.31-11.29-9.51a1.17,1.17,0,0,0-.88.27c-2.24,2.06-1.63,2.89.39,5.63l.38.53c2.27,3.1,7.42,9.93,7.47,10l.06.07-.09,0A12.39,12.39,0,0,0,316.36,319.93Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.9,321.48a24,24,0,0,1-1.56-2.5,59.78,59.78,0,0,0-4-5.81c-1.71-2.17-3.47-4-4.63-5.39a10.57,10.57,0,0,1-1.68-2.44c.07,0,.74.86,2,2.2s3,3.11,4.76,5.31a42.79,42.79,0,0,1,4,5.95A13,13,0,0,1,339.9,321.48Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.25,325a13.24,13.24,0,0,1-1.54-2c-.91-1.23-2.18-2.92-3.66-4.73s-2.88-3.38-3.91-4.51a13.76,13.76,0,0,1-1.62-1.89,10.73,10.73,0,0,1,1.88,1.63,56,56,0,0,1,7.62,9.29A10.41,10.41,0,0,1,333.25,325Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.53,330.55a36.63,36.63,0,0,1-4.7-4.68c-1.24-1.35-2.33-2.59-3.12-3.49a14.9,14.9,0,0,1-1.26-1.48c.16-.17,2.31,1.91,4.76,4.62A50.4,50.4,0,0,1,329.53,330.55Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M348.05,363.63s20.05,49.85,34.09,59.6,31.52,6.79,40.87-2c0,0-12.64,11.42-26.4,1S348.05,363.63,348.05,363.63Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M382.34,306.85c-1.17,9.92,1.53,18.9.75,28.79-.29,3.79-.8,7.65,0,11.37,1.48,7,8.28,13.93,13.7,18.58-3.88-19.2-8.78-40-14.45-58.74"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M381.86,416.51a2.43,2.43,0,1,1,.94-3.43A2.51,2.51,0,0,1,381.86,416.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.06,394.27a2.18,2.18,0,1,1,.51-3.33A2.4,2.4,0,0,1,364.06,394.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,262.68a12.93,12.93,0,0,0-7.12-3.13c-12.51-1.86-26.87,6-23,27.16l10.45,44,8.5,34.93L378.21,348.4l-32.29,12.33s35.84,49.12,47.37,58.92S413,427.43,423,421.27c0,0,12.36-5.63,12.26-41C435.18,349.7,428.51,282.68,408,262.68Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.23,411.86s-.08.2-.25.57l-.76,1.67a24.4,24.4,0,0,1-4.07,5.72,24,24,0,0,1-9.3,6,20.22,20.22,0,0,1-6.86,1.22,18.36,18.36,0,0,1-7.59-1.8c-5-2.33-9.65-6.36-13.91-11.17s-8.7-10.08-13.22-15.73c-9-11.32-18.65-24-28.56-37.5l-.2-.27.32-.13,1.51-.57,30.78-11.74.15-.06.11.11,18.56,17.2-.38.23c-2.24-9.34-4.3-17.91-6.13-25.53s-3.49-14.23-4.84-19.7-2.39-9.76-3.11-12.71l-.81-3.36c-.08-.37-.15-.66-.19-.87a1.09,1.09,0,0,1-.06-.29,1.09,1.09,0,0,1,.06.29c.06.21.13.49.23.86.21.77.5,1.89.88,3.34.75,2.95,1.84,7.24,3.23,12.68s3.09,12.08,4.95,19.69l6.21,25.5.18.74-.56-.52L378,348.58l.26.05-30.78,11.76L346,361l.12-.4c9.9,13.49,19.51,26.19,28.51,37.51,4.51,5.65,8.86,11,13.16,15.75s8.82,8.8,13.75,11.12a18.06,18.06,0,0,0,7.45,1.8,19.81,19.81,0,0,0,6.76-1.17,23.82,23.82,0,0,0,9.24-5.9,24.68,24.68,0,0,0,4.12-5.63l.81-1.64C430.12,412,430.23,411.86,430.23,411.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.29,264.31c0,.09-1.79.11-4.6.69a30.63,30.63,0,0,0-4.8,1.42,19.47,19.47,0,0,0-5.32,3,14.23,14.23,0,0,0-3.61,4.83,28.18,28.18,0,0,0-1.66,4.73c-.36,1.39-.6,2.53-.78,3.31a5.35,5.35,0,0,1-.33,1.21,6,6,0,0,1,.13-1.24c.12-.8.31-2,.63-3.37a25.62,25.62,0,0,1,1.57-4.84,14.24,14.24,0,0,1,3.72-5,19.18,19.18,0,0,1,5.47-3,28.22,28.22,0,0,1,4.91-1.34,25,25,0,0,1,3.41-.36A4.29,4.29,0,0,1,401.29,264.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.42,376.08a19.54,19.54,0,0,0-2.16-4,17.78,17.78,0,0,0-8.85-6.14,29.76,29.76,0,0,0-10.89-1c-1.41.1-2.55.24-3.34.33a5.91,5.91,0,0,1-1.23.1,5.23,5.23,0,0,1,1.2-.3,33.07,33.07,0,0,1,3.34-.49,27.65,27.65,0,0,1,11.08.91,17.37,17.37,0,0,1,9,6.41,12.27,12.27,0,0,1,1.56,3A4.92,4.92,0,0,1,422.42,376.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,380.14c-.09,0-.4-1-1.08-2.56a26.4,26.4,0,0,0-8.13-10.35c-1.36-1-2.27-1.58-2.23-1.66a9.56,9.56,0,0,1,2.45,1.36,22.88,22.88,0,0,1,8.25,10.51A9.7,9.7,0,0,1,407,380.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.69,292.08a2.66,2.66,0,1,1,3.28-1.75A2.63,2.63,0,0,1,385.69,292.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.38,293.67a3,3,0,1,1,.78-3.85A2.79,2.79,0,0,1,411.38,293.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.14,314c-1.43-.11-2.49-1.63-2.36-3.4s1.39-3.13,2.83-3S403.1,309.2,403,311,401.58,314.1,400.14,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.29,322.84a2.57,2.57,0,1,1,1.18-3.46A2.58,2.58,0,0,1,419.29,322.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.58,339.91a2.75,2.75,0,1,1-.23-3.77A2.68,2.68,0,0,1,399.58,339.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.41,348.73a2.52,2.52,0,1,1-3.54.76A2.57,2.57,0,0,1,416.41,348.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.89,367.73a2.18,2.18,0,1,1,2.46-2.31A2.41,2.41,0,0,1,427.89,367.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.54,383.47a2.31,2.31,0,1,1,2.86-2A2.48,2.48,0,0,1,414.54,383.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.88,397a2.76,2.76,0,1,1,.27-3.78A2.68,2.68,0,0,1,405.88,397Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.28,413.44a3.11,3.11,0,1,1-2.75,2.95A2.87,2.87,0,0,1,404.28,413.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.88,390.68a2.13,2.13,0,0,1-1,1.76,2.87,2.87,0,0,1-4.09-1.37,2.12,2.12,0,0,1,.27-2,3.4,3.4,0,0,1,1.54-1.21,2.18,2.18,0,0,1,1.57-.13,2.21,2.21,0,0,1,1.18,1.05A3.4,3.4,0,0,1,384.88,390.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.3,377.05a2.13,2.13,0,1,1,3.05-1.33A2.38,2.38,0,0,1,391.3,377.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.92,368.77a2.16,2.16,0,0,1-1.71,1.16,3.6,3.6,0,0,1-3.8-2.95,2.15,2.15,0,0,1,.7-2,3.16,3.16,0,0,1,4.81,3.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.63,400.31a2.08,2.08,0,0,1,1.07,1.93,5.31,5.31,0,0,1-3.68,4.91,2.09,2.09,0,0,1-2.16-.49,2.52,2.52,0,0,1-.46-2.1,5.65,5.65,0,0,1,1.08-2.4,5.49,5.49,0,0,1,2-1.7A2.49,2.49,0,0,1,425.63,400.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,250.54s-29.16,1.61-32.44,30.7c-2.13,18.9-19.39,93.27-11.14,103,8.5,10,26.88,21.68,39.54,3.54s25.12-87,25.12-87L291,286.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.41,269.84s-8.23-12.21-8.39-14.67.16-7.71.93-7.87c0,0-.77-2,.15-3.08s2.93-2.93,2.93-2.93-.62-3.08.62-3.85,9.4-7.71,9.4-7.71,3.39-6.94,5.24-7.09,5.09-.31,6.32.61,6.48,5.38,6.48,5.38h2.46c.78,0,3.24,4.64,3.24,4.64s2.62.31,3.24,1.7-1.23,18.65-1.23,18.65l-6.17,19.58-5,27.13-25.31-13.62Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.41,269.84a1.15,1.15,0,0,1-.06.28c-.06.21-.14.48-.24.84q-.35,1.16-1,3.3c-.87,2.91-2.13,7.14-3.72,12.49l-.07-.17,25.34,13.55-.32.16c1.52-8.23,3.2-17.38,5-27.13v0h0c2-6.26,4-12.83,6.16-19.58v0c.14-1.37.28-2.84.43-4.31.3-3.09.57-6.15.77-9.17.09-1.51.19-3,.13-4.48a1.63,1.63,0,0,0-1.08-1.5,6.53,6.53,0,0,0-2-.61l-.13,0-.06-.12a40.58,40.58,0,0,0-2.11-3.5,7,7,0,0,0-.62-.77,1,1,0,0,0-.16-.14.33.33,0,0,0-.12-.08,2.12,2.12,0,0,0-.45,0H321l-.07-.06-4.82-4-1.18-1a3,3,0,0,0-1.22-.75,10.45,10.45,0,0,0-2.91-.33c-.49,0-1,0-1.47,0A4.39,4.39,0,0,0,308,223a7.07,7.07,0,0,0-1.91,2,40.74,40.74,0,0,0-2.82,4.83l0,0,0,0q-3.37,2.85-6.52,5.43c-1,.84-2.12,1.71-3.11,2.43a2.68,2.68,0,0,0-.49,1.67,8.44,8.44,0,0,0,.14,1.82l0,.11-.08.07c-1,.88-1.87,1.76-2.69,2.65s-.7,2.15-.36,3.16l.07.21-.2,0a.92.92,0,0,0-.26.48,3.65,3.65,0,0,0-.17.67,13.33,13.33,0,0,0-.21,1.39c-.1.91-.16,1.81-.19,2.69a23.5,23.5,0,0,0,0,2.53,9.45,9.45,0,0,0,.81,2.19c1.38,2.74,2.78,5,3.9,6.81l2.62,4.16.68,1.07a2.68,2.68,0,0,1,.22.38s-.09-.11-.26-.35l-.72-1.05c-.63-.92-1.55-2.3-2.7-4.11s-2.57-4-4-6.79a9.22,9.22,0,0,1-.86-2.28,24.28,24.28,0,0,1-.05-2.57c0-.88.08-1.79.17-2.72a14.13,14.13,0,0,1,.21-1.41,6.25,6.25,0,0,1,.17-.72c.05-.12.09-.24.15-.37a.62.62,0,0,1,.37-.33l-.12.23a4.93,4.93,0,0,1-.32-1.79,2.62,2.62,0,0,1,.18-1,2.71,2.71,0,0,1,.55-.8c.84-.91,1.75-1.79,2.7-2.68l-.06.18a10.12,10.12,0,0,1-.16-1.91,3.11,3.11,0,0,1,.6-1.94c1.09-.81,2.08-1.6,3.14-2.48,2.09-1.72,4.25-3.54,6.49-5.44l-.06.07a40.59,40.59,0,0,1,2.84-4.9,7.35,7.35,0,0,1,2.08-2.16,4.36,4.36,0,0,1,1.54-.24c.49,0,1-.05,1.49-.05a10.7,10.7,0,0,1,3.06.35,3.3,3.3,0,0,1,.75.33,6.38,6.38,0,0,1,.62.49l1.18,1,4.84,4-.16-.06h2a2.74,2.74,0,0,1,.55,0,.68.68,0,0,1,.33.16,2,2,0,0,1,.21.2,7.28,7.28,0,0,1,.67.82,40,40,0,0,1,2.15,3.56l-.2-.13a6.82,6.82,0,0,1,2.2.66,3.25,3.25,0,0,1,1,.74,1.8,1.8,0,0,1,.4,1.18,43.13,43.13,0,0,1-.12,4.55c-.2,3-.47,6.09-.77,9.19-.15,1.47-.3,2.95-.43,4.31v0c-2.12,6.75-4.2,13.32-6.17,19.58v0c-1.82,9.75-3.53,18.9-5.06,27.12l-.06.3-.27-.15-25.27-13.68-.11-.06,0-.11c1.64-5.31,2.94-9.51,3.84-12.4l1-3.3.27-.85A1.67,1.67,0,0,1,297.41,269.84Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.13,241.46a2.69,2.69,0,0,1-2.34-.5,6.93,6.93,0,0,1-1.86-1.88,13.4,13.4,0,0,1-1.68-2.75,7.66,7.66,0,0,1-.33-3.22,7.55,7.55,0,0,1,.43-2.61,3.16,3.16,0,0,1,1.1-1.42c.36-.24.61-.27.62-.24a3.5,3.5,0,0,0-1.37,1.79,7.65,7.65,0,0,0-.3,2.49,7.85,7.85,0,0,0,.33,3,15.34,15.34,0,0,0,1.59,2.66,7.48,7.48,0,0,0,1.67,1.85A4.58,4.58,0,0,0,325.13,241.46Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.65,251.63a5.25,5.25,0,0,1-2-.49,8.08,8.08,0,0,1-2-1,6.13,6.13,0,0,1-1.82-2.12,8.18,8.18,0,0,1-.65-4.94,5.29,5.29,0,0,1,.55-2,14.66,14.66,0,0,1-.19,2,8.84,8.84,0,0,0,.75,4.66,7,7,0,0,0,3.5,3.07A16.47,16.47,0,0,1,327.65,251.63Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.89,268.1a49.79,49.79,0,0,0-4-5.85,51.38,51.38,0,0,0-5.13-4.87,6.74,6.74,0,0,1,1.81,1.07,21.37,21.37,0,0,1,3.72,3.46,21.93,21.93,0,0,1,2.81,4.23A6.33,6.33,0,0,1,319.89,268.1Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.31,265.59c-.09,0-.18-.73-.68-1.78a10,10,0,0,0-2.84-3.49,24.52,24.52,0,0,0-3.9-2.43,8,8,0,0,1-1.68-1,6.21,6.21,0,0,1,1.84.63,17.85,17.85,0,0,1,4.06,2.35,9.16,9.16,0,0,1,2.86,3.75A3.5,3.5,0,0,1,321.31,265.59Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.6,273.57s-.23.6-1,1.29a6.83,6.83,0,0,1-7.38,1.22c-.92-.42-1.37-.87-1.33-.91a13.89,13.89,0,0,1,1.46.56,7.4,7.4,0,0,0,7-1.15C317.15,274,317.53,273.52,317.6,273.57Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.29,230.47a23.43,23.43,0,0,1,3.87-2.43,5.2,5.2,0,0,1,1.84-.5,5.25,5.25,0,0,1,2.19.52,25.67,25.67,0,0,1,8.52,5.81,7.07,7.07,0,0,1,1.83,2.74,7.94,7.94,0,0,1,.22,2.53q0,3-.1,5.94a5.09,5.09,0,0,1-.32,2.06,2.72,2.72,0,0,1-4.25.71",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.09,247.85a3.23,3.23,0,0,0,1.32.59,2.85,2.85,0,0,0,1.64-.25,2.23,2.23,0,0,0,1.3-1.63,18.41,18.41,0,0,0,.12-2.77q0-1.53,0-3.24a19.57,19.57,0,0,0-.11-3.5,6.48,6.48,0,0,0-1.94-3.08,26,26,0,0,0-5.8-4.45,25.06,25.06,0,0,0-2.88-1.39,3.75,3.75,0,0,0-2.62-.26,13,13,0,0,0-3.57,1.82,7,7,0,0,1-1.29.78,9.73,9.73,0,0,1,1.17-.94,11.71,11.71,0,0,1,3.59-2,3.38,3.38,0,0,1,1.4-.17,5.47,5.47,0,0,1,1.47.37,26.75,26.75,0,0,1,3,1.38,25.58,25.58,0,0,1,5.94,4.51,6.88,6.88,0,0,1,2.07,3.33,19.38,19.38,0,0,1,.09,3.62c0,1.14-.06,2.22-.08,3.23a16.21,16.21,0,0,1-.2,2.85,2.56,2.56,0,0,1-1.53,1.82,3,3,0,0,1-1.79.18,2.34,2.34,0,0,1-1-.49C316.16,248,316.08,247.86,316.09,247.85Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.89,253.58a4.86,4.86,0,0,0,5.58,1c.16-2,.32-4,.47-6a7.37,7.37,0,0,0-.17-3,7,7,0,0,0-1.12-1.87,56,56,0,0,0-5.47-6.52,5.17,5.17,0,0,0-6.85-1.46,32.12,32.12,0,0,0-10,6.72",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.29,242.46s.09-.14.3-.36.52-.54.94-.94a30.39,30.39,0,0,1,3.86-3,33.48,33.48,0,0,1,2.93-1.71,19.68,19.68,0,0,1,3.62-1.5,4.38,4.38,0,0,1,2.19,0,5.64,5.64,0,0,1,2,1,26.65,26.65,0,0,1,3.28,3.27c1.09,1.27,2.08,2.55,3,3.8a14.88,14.88,0,0,1,1.31,1.93,4.78,4.78,0,0,1,.49,2.22c-.15,2.88-.44,5.36-.61,7.41v.11l-.08,0a5,5,0,0,1-4.42-.11,4.36,4.36,0,0,1-1-.71c-.19-.2-.27-.32-.26-.33a7.53,7.53,0,0,0,1.33.86,4.81,4.81,0,0,0,4.17,0l-.1.15c.12-2.05.36-4.59.48-7.38a4.1,4.1,0,0,0-.45-2,14,14,0,0,0-1.28-1.85c-.94-1.24-1.93-2.52-3-3.77a27.66,27.66,0,0,0-3.19-3.21,5.24,5.24,0,0,0-1.84-1,3.9,3.9,0,0,0-1.95,0,19.56,19.56,0,0,0-3.53,1.42c-1.08.53-2.06,1.09-2.93,1.63a35.66,35.66,0,0,0-3.92,2.86A17.52,17.52,0,0,1,292.29,242.46Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.16,253.27c.08,0,.06.63-.55,1.27a10.63,10.63,0,0,1-2.62,2,7.89,7.89,0,0,1-4.47,1.2,30.74,30.74,0,0,0,4.22-1.66,15.84,15.84,0,0,0,2.61-1.82A4.66,4.66,0,0,0,302.16,253.27Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18,251.24a2.77,2.77,0,0,0,2.19,1.78A4.77,4.77,0,0,0,305,256.8a2.41,2.41,0,0,0,1.45.67c1.09,0,1.88-1,2.44-1.91.66-1.1,1.27-2.23,1.83-3.38a1.87,1.87,0,0,0-.33-2.74q-2-2-4.1-4a6.78,6.78,0,0,0-2.07-1.55,6.67,6.67,0,0,0-3.52,0c-3.81.67-7.3,1.54-10.56,3.64",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.09,247.47s.11-.11.34-.27a11.63,11.63,0,0,1,1.05-.66,21.1,21.1,0,0,1,4.17-1.77,38.74,38.74,0,0,1,6.59-1.39,4.82,4.82,0,0,1,2,.25,5.5,5.5,0,0,1,1.74,1.19l3,3,1,1a9.41,9.41,0,0,1,1,1.07,1.81,1.81,0,0,1,.19,1.54,5.77,5.77,0,0,1-.57,1.28L309.43,255a7.47,7.47,0,0,1-1.42,2,2.64,2.64,0,0,1-1.08.61,1.93,1.93,0,0,1-1.19-.08,3.92,3.92,0,0,1-1.6-1.36,4.84,4.84,0,0,1-.9-3.17l.11.14a2.79,2.79,0,0,1-1.87-1.2,2.06,2.06,0,0,1-.26-.52c0-.12-.05-.19,0-.19s.11.24.41.63a2.77,2.77,0,0,0,1.8,1h.12V253a4.61,4.61,0,0,0,.94,2.93,3.46,3.46,0,0,0,1.45,1.19,1.68,1.68,0,0,0,1.81-.47,7.16,7.16,0,0,0,1.31-2c.4-.73.8-1.49,1.22-2.27s.86-1.65.4-2.31a7.63,7.63,0,0,0-.93-1l-1-1-3-3a5.27,5.27,0,0,0-1.57-1.1,4.22,4.22,0,0,0-1.8-.23,42.07,42.07,0,0,0-6.51,1.26,24.65,24.65,0,0,0-4.19,1.6A14.79,14.79,0,0,1,290.09,247.47Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.84,253.49c0,.06-.28.28-.86.41a4.68,4.68,0,0,1-2.3-.15,6,6,0,0,1-2.75-1.6c.09-.16,1.32.58,2.9,1.1a6.14,6.14,0,0,0,2.1.29C301.47,253.51,301.81,253.42,301.84,253.49Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.4,368.46s0-.15,0-.45,0-.78.05-1.36a24.89,24.89,0,0,1,1-5.1,44.18,44.18,0,0,1,3.23-7.61c1.47-2.87,3.42-6,5.43-9.53a83.21,83.21,0,0,0,5.25-12.22c1.66-4.49,3.31-9.39,5.63-14.31,4.46-9.89,9-21,13.77-32.69l.11-.27.25.14,6.29,3.33L319,300.91l.17.09,0,.2c-1.36,4.94-2.63,9.72-3.74,14.33q-.84,3.45-1.54,6.77c-.46,2.21-.9,4.38-1.4,6.46-1,4.17-2,8.07-2.64,11.77s-1.46,7.08-2.24,10.14c-1.57,6.1-3,10.91-4,14.2-.51,1.63-.91,2.89-1.18,3.77-.14.41-.24.73-.32,1l-.12.33a1.74,1.74,0,0,1,.08-.34l.27-1c.26-.88.63-2.15,1.1-3.79.95-3.31,2.35-8.12,3.88-14.23.75-3.06,1.55-6.43,2.17-10.13s1.62-7.63,2.59-11.8c.49-2.08.92-4.23,1.38-6.45s1-4.48,1.52-6.79c1.1-4.62,2.37-9.41,3.72-14.35l.12.28-23.56-12.5-6.28-3.33.36-.13c-4.81,11.7-9.33,22.8-13.82,32.68-2.33,4.9-4,9.77-5.67,14.27a84.36,84.36,0,0,1-5.33,12.25c-2,3.53-4,6.63-5.5,9.48a45.9,45.9,0,0,0-3.29,7.54,27.32,27.32,0,0,0-1.11,5.05c0,.58-.07,1-.1,1.35S254.4,368.46,254.4,368.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.17,372.27c-1.36.46-2.94-.59-3.52-2.33s.05-3.52,1.42-4,2.94.59,3.52,2.33S272.53,371.82,271.17,372.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,345.75a2,2,0,0,1,.2,2.08,3.8,3.8,0,0,1-4.86,1.81,2,2,0,0,1-1.21-1.7,2.93,2.93,0,0,1,.63-1.93,3.37,3.37,0,0,1,1.55-1.19,3.41,3.41,0,0,1,1.95-.12A3,3,0,0,1,285,345.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.68,373.53a3.22,3.22,0,1,1,2.81-3A2.92,2.92,0,0,1,289.68,373.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.15,328.52a2.11,2.11,0,0,1,.68,1.92A3.18,3.18,0,0,1,300,332.9a2.14,2.14,0,0,1-1.45-1.44,3.17,3.17,0,0,1,.08-2,2.56,2.56,0,0,1,1-1.38,2.6,2.6,0,0,1,1.69-.35A3.15,3.15,0,0,1,303.15,328.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.26,313a3,3,0,1,1-3.67-1.38A2.78,2.78,0,0,1,289.26,313Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.73,306.64a2,2,0,0,1-2.19.6,5.65,5.65,0,0,1-4.05-5.4,2,2,0,0,1,1.19-1.93,2.58,2.58,0,0,1,2.14.37,6.78,6.78,0,0,1,2,1.8,6.71,6.71,0,0,1,1.17,2.39A2.6,2.6,0,0,1,302.73,306.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.22,319.68a2.87,2.87,0,0,1,.81,1.88,3.74,3.74,0,0,1-1.76,3.52,2.86,2.86,0,0,1-2,.49,2,2,0,0,1-1.57-1.42,4.06,4.06,0,0,1,2.43-4.87A2,2,0,0,1,268.22,319.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,303.27a3,3,0,1,1,.12-4A2.83,2.83,0,0,1,272,303.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.46,278c1.34-.53,3.18.92,4.1,3.25s.6,4.64-.74,5.17-3.17-.92-4.1-3.24S276.13,278.57,277.46,278Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.07,266.74a3,3,0,1,1-3.33-2.14A2.81,2.81,0,0,1,285.07,266.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.77,124.6a6.3,6.3,0,0,1-2.57-.62,6.31,6.31,0,0,1,2.63-.33c1.44,0,2.59.27,2.57.63S380.2,124.78,378.77,124.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.27,129.59c-1-1.05-1.68-2-1.57-2.13s1.11.53,2.22,1.44,1.82,1.87,1.57,2.14S377.25,130.65,376.27,129.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.14,131.81a6.23,6.23,0,0,1,.17-2.64,6.21,6.21,0,0,1,.77,2.53c.27,1.42.19,2.6-.17,2.64S371.21,133.25,371.14,131.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.78,130.21c.87-1.14,1.69-2,1.83-1.91a6.18,6.18,0,0,1-1,2.43c-.71,1.26-1.53,2.12-1.83,1.92S364.91,131.36,365.78,130.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.71,125.55a6.07,6.07,0,0,1,2.63-.29,6.45,6.45,0,0,1-2.36,1.2c-1.34.51-2.52.64-2.63.3S361.31,125.87,362.71,125.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.35,120c1.28.66,2.27,1.31,2.2,1.46a6.33,6.33,0,0,1-2.58-.59c-1.35-.48-2.34-1.13-2.2-1.47S362.07,119.34,363.35,120Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.41,116.16a6.27,6.27,0,0,1,.75,2.53c-.15.08-.87-.87-1.6-2.11s-1.07-2.37-.75-2.53S366.85,114.83,367.41,116.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,115.82a6.42,6.42,0,0,1-1.06,2.43,6.23,6.23,0,0,1,.13-2.65c.23-1.42.7-2.51,1.06-2.42S373.41,114.45,373,115.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.48,119.15a6.31,6.31,0,0,1-2.37,1.18c-.1-.13.71-1,1.8-1.94s2.15-1.47,2.36-1.18S378.68,118.37,377.48,119.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.34,170.06a7.21,7.21,0,0,1-2.56-.67,7.18,7.18,0,0,1,2.63-.29c1.44,0,2.59.28,2.56.67S268.76,170.29,267.34,170.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19,174.68a7.32,7.32,0,0,1-1.08-2.42c.12-.08,1,.77,1.87,1.88s1.4,2.2,1.07,2.42S264.89,175.94,264.19,174.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.61,175.11a7.29,7.29,0,0,1,1.22-2.35,7,7,0,0,1-.3,2.63c-.3,1.4-.85,2.46-1.22,2.35S258.07,176.44,258.61,175.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.8,171a7.52,7.52,0,0,1,2.6-.51,7.37,7.37,0,0,1-2.25,1.41c-1.28.64-2.45.87-2.6.51S253.42,171.42,254.8,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.62,165.48a7.25,7.25,0,0,1,2,1.71,7.18,7.18,0,0,1-2.5-.88c-1.3-.6-2.21-1.37-2-1.71S254.44,164.66,255.62,165.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.45,162.67a7.09,7.09,0,0,1-.08,2.65,7.76,7.76,0,0,1-.87-2.5c-.34-1.4-.3-2.59.08-2.65S260.36,161.23,260.45,162.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.67,164.69a7.1,7.1,0,0,1-2.12,1.59A7.34,7.34,0,0,1,265,164c.88-1.14,1.83-1.85,2.12-1.59S266.73,163.73,265.67,164.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.82,138.55a13.53,13.53,0,0,1-2.54-.72,14.22,14.22,0,0,1,2.63-.18c1.44,0,2.59.29,2.55.72S403.22,138.88,401.82,138.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,142a13.78,13.78,0,0,1-.09-2.64,15.55,15.55,0,0,1,1,2.46c.47,1.35.52,2.55.1,2.64S398.15,143.4,398,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.61,139.42a14.07,14.07,0,0,1,2.48-.92,13.22,13.22,0,0,1-2,1.7c-1.15.87-2.27,1.28-2.48.91S392.29,140,393.61,139.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.67,134.43a13.05,13.05,0,0,1,1.63,2.08,14.27,14.27,0,0,1-2.23-1.41c-1.18-.82-1.92-1.76-1.64-2.08S393.73,133.34,394.67,134.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.74,133.89a13.34,13.34,0,0,1-1.47,2.19,15.13,15.13,0,0,1,.64-2.56c.42-1.37,1.08-2.37,1.47-2.19S400.48,132.66,399.74,133.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.67,231.66a9.42,9.42,0,0,1-1.45.09c-.94,0-2.29,0-4,0-3.34,0-7.95-.14-13-.32l-13-.47-4-.15a7.75,7.75,0,0,1-1.45-.11,7,7,0,0,1,1.45-.09c.94,0,2.29,0,4,0,3.34,0,7.95.14,13,.31l13,.47,4,.15A7.12,7.12,0,0,1,286.67,231.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.65,226.83c-.06.13-5.81-2.17-12.85-5.14s-12.71-5.5-12.66-5.63,5.81,2.17,12.86,5.15S285.71,226.7,285.65,226.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.15,237.07a62.28,62.28,0,0,1-6.94,4.1,65.41,65.41,0,0,1-7.2,3.64,61.9,61.9,0,0,1,6.95-4.1A61.74,61.74,0,0,1,286.15,237.07Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.5dba74eaaf172389003d49962837ce0c.svg";
export { ForwardRef as ReactComponent };